import debug from "../debug";
const log = debug("LicenceCheck");

function getLicenceId(appId: string, accountId: string): string {
    return `${appId}-accountId-${accountId}`; // licenceId needs to start with appId
}

function getPaymentUrl(licenceHost: string, appId: string, accountId: string, stripePriceId: string): string {
    const licenceId = getLicenceId(appId, accountId);

    return `${licenceHost}/payment/stripe/${appId}/${licenceId}/${stripePriceId}`;
}

async function getLicence(licenceHost: string, appId: string, sessionToken: string): Promise<string> {
    log("getLicence", { sessionToken });
    const validPromise = fetch(`${licenceHost}/check`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ appId: appId, sessionToken })
    }).then((res) => res.text());

    return validPromise;
}

const functions = {
    getLicenceId,
    getLicence,
    getPaymentUrl
};

export default functions;
